<template>
  <div v-if="!loading">
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        searchnew: this.search,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:new="createHandler"
      v-on:save="saveHandler"
      v-on:delete="isConfirm = !isConfirm"
      v-on:error="errorHandler"
    />

    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>

    <div v-if="isConfirm">
      <app-confirm
        v-bind:parentObject="{
          pageTitleValue: this.pageTitleValue,
          isConfirm: this.isConfirm,
        }"
        v-on:confirm="deleteHandler($event)"
        v-on:cancelConfirm="isConfirm = !isConfirm"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import AppraisalExerciseForm from "../../../components/performance/appraisalexercise/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": AppraisalExerciseForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('appraisalexerciserecords.editappraisalexercisesetup'),
      pageTitleValue: "",
      formData: [],
      // formData: {
      //   appexercisecode: null,
      //   appexercisedesc: null,
      //   assessmenttypeid : null,
      //   startdate : null,
      //   enddate: null,
      //   rankingsetid: null,
      //   remarks: null,
      //   stamp: 0,
      //   userid: this.$store.getters.userId,
      // },
      loading: true,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: true,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    loadAppraisalExercise() {
      const vm = this;

      this.$store.dispatch('get', {url: "/appraisalexercise/" + this.id})
        .then((res) => {
          if (
            res.data.rec[0].isincrementpost == "N" ||
            res.data.rec[0].isincrementpost == null
          ) {
            vm.formData.isincrementpost = false;
          } else {
            vm.formData.isincrementpost = true;
          }

          if (res.data.rec[0].isbonuspost == "N" || 
              res.data.rec[0].isbonuspost == null
          ) {
            vm.formData.isbonuspost = false;
          } else {
            vm.formData.isbonuspost = true;
          }

            if (res.data.rec[0].startdate) {
            vm.formData.startdate = moment(res.data.rec[0].startdate).format(
              "YYYY-MM-DD"
            );
          }

          if (res.data.rec[0].enddate) {
            vm.formData.enddate = moment(res.data.rec[0].enddate).format(
              "YYYY-MM-DD"
            );
          }

          vm.formData.appexercisecode = res.data.rec[0].appexercisecode;
          vm.formData.appexercisedesc = res.data.rec[0].appexercisedesc;
          vm.formData.assessmenttypeid = res.data.rec[0].assessmenttypeid;
          vm.formData.rankingsetid = res.data.rec[0].rankingsetid;
          vm.formData.remarks = res.data.rec[0].remarks;
          vm.formData.id = res.data.rec[0].id;
      
          vm.pageTitleValue = res.data.rec[0].appexercisecode;
            vm.formData.stamp = res.data.rec[0].stamp;
          vm.formData.userid = this.$store.getters.userId;

          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }

      this.$store.dispatch('put', {url: "/appraisalexercise/" + this.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "appraisalexerciselist" , params: { search: this.search} });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    deleteHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }

      this.$store.dispatch('delete', {url:
            "/appraisalexercise/" +
            this.id +
            "/" +
            this.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "appraisalexerciselist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    createHandler() {
      this.$router.push({ name: "appraisalexercisenew" });
    },
  },

  mounted() {
   // this.editMode = true;
    this.loadAppraisalExercise();
  },
};
</script>